function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.527 0.833313L17.8603 4.16665L14.527 7.49998",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.86035 4.16669L17.8604 4.16669",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19368 19.1667L2.86035 15.8333L6.19368 12.5",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8604 15.8333H2.86035",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsBlue);
export default __webpack_public_path__ + "static/media/transactions-blue.53e5eff72de349f6d561395272c02280.svg";
export { ForwardRef as ReactComponent };